import React from 'react';
import { useNavigate } from 'react-router-dom';
import NoDataFound from '../noDataFound';
import { IMG_BASE_PATH } from 'utils/constants';
import { getCookie } from 'utils/commonFunctions';
import config from 'utils/config';

const Eot = () => {
  const navigate = useNavigate();
  const gameCookie = getCookie(config.gameCookieName);

  return (
    <div className='si-eot'>
      <NoDataFound
        noDataThumb={`${IMG_BASE_PATH}images/no-data/eot.svg`}
        noDataTitle='End Of Tournament'
        noDataCaption={
          gameCookie?.guid
            ? 'Check the final leaderboard to see where you finished!'
            : 'Thank you for joining us! <span class="si-noData__caption--block">We can’t wait to see you in the next ICC Tournament!</span>'
        }
        noDataCta={gameCookie?.guid ? 'View Leaderboard' : ''}
        onClick={gameCookie?.guid ? () => navigate('/leaderboard') : undefined}
        isLoggedIn={gameCookie?.guid}
      />
    </div>
  );
};

export default Eot;
